import{Button as yt,InlineMessage as Lt,Input as wt,Row as At}from"@appcues/sonar";import{useForm as St}from"react-hook-form";import{Button as vt,Form as ht,InlineMessage as kt,Input as bt}from"@appcues/sonar";import It,{css as Nt}from"styled-components";var xt=Nt`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  input[type='number'] {
    -moz-appearance: textfield;
  }
`,Re=It(ht)`
  padding: var(--spacing-regular);
  padding-bottom: 0;

  ${vt} {
    flex: 1;
  }

  ${bt} {
    flex: 2;
    ${xt};
  }

  ${kt} {
    padding-top: var(--spacing-small);
  }
`;import{jsx as de,jsxs as Ee}from"react/jsx-runtime";var D=({user:e,isSpoofing:t,onSpoof:i})=>{let{register:n,handleSubmit:r,formState:{errors:s,isSubmitting:a},setError:c}=St(),{isAdmin:m}=e!=null?e:{};return!m||t?null:Ee(Re,{onSubmit:r(async({accountId:p})=>{try{await i(p)}catch(h){c("accountId",{message:"Failed to spoof"})}}),children:[Ee(At,{xAlign:"center",spacing:"small",children:[de(wt,{id:"accountId",placeholder:"Account ID",type:"number",...n("accountId",{required:"Can't be empty"})}),de(yt,{type:"submit",disabled:a,children:"Spoof"})]}),s.accountId&&de(Lt,{variant:"error",children:s.accountId.message})]})};import Be from"styled-components";var Fe=Be.header`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-bottom: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
  padding-top: var(
    ${({$size:e})=>e==="regular"?"--spacing-large":"--spacing-x-large"}
  );
`,We=Be.span`
  align-items: center;
  color: var(--color-blurple-600);
  display: flex;
  font-size: var(--icon-size-large);
  justify-content: center;

  svg {
    height: 30px;
    width: 24px;

    path {
      fill: currentColor;
    }
  }
`;import{jsx as $}from"react/jsx-runtime";var O=({size:e="regular"})=>$(Fe,{$size:e,children:$("a",{href:"/",children:$(We,{children:$("svg",{viewBox:"0 0 1600 2000",xmlns:"http://www.w3.org/2000/svg",role:"img","aria-label":"Appcues logo",children:$("path",{d:"M695.6 1083.4l555.9 870.5c14.1 21.2 35.3 31 60.7 31h206c39.5 0 70.5-31 70.5-70.5V70.4c0-66.3-83.2-95.9-127-43.7L695.6 998.8c-16.9 22.6-16.9 57.8 0 84.6zM70.6 1985h366.8c39.5 0 70.5-31 70.5-70.5V1446c0-66.3-83.2-95.9-127-43.7L14.1 1870.7c-35.2 48 0 114.3 56.5 114.3z"})})})})});import H from"styled-components";import{Stack as Tt}from"@appcues/sonar";var De=H(Tt).attrs({spacing:"none"})`
  position: fixed;
  bottom: 0;
  left: 0;
  top: 0;
  width: 240px;
  background-color: var(--color-neutral-0);
  border-right: 1px solid var(--border-default);
  display: flex;
  flex-direction: column;
  /*
  * This z-index is chosen because it is bigger than the biggest z-index currently
  * found in studio excluding Modals, which is in the studio classic TabsRoot
  * component (z-index: 3000). We will look at standardizing our use of z-index in
  * studio in the future.
  */
  z-index: 4000;
`,$e=H.div`
  overflow-y: auto;
  flex-grow: 1;
`,Oe=H.nav`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`,He=H.ul`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
  padding-bottom: var(--spacing-small);
  padding-top: var(--spacing-small);
  list-style-type: none;
`,Y=H.div`
  width: 18px;
  height: 14px;
`;import{Icon as Pt,Row as Ct,Text as Mt}from"@appcues/sonar";import ze from"styled-components";import{Text as Ge}from"@appcues/sonar";var J=ze.li`
  a {
    height: 40px;
    display: flex;
    text-decoration: none;
    padding-left: var(--spacing-large);
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }
    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ge} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ue=ze.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Ge} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as Z,jsxs as Rt}from"react/jsx-runtime";var _e=({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,className:c,external:m=!1,isSubItem:d=!1,...p})=>Z(J,{className:c,children:Z(m||!n?"a":n,{isSubItem:d,to:r,end:s,className:a?"active":"",...p,children:Rt(Ct,{spacing:"small",yAlign:"center",children:[i&&i,t&&Z(Pt,{icon:t,colorToken:"foreground-secondary",size:"small"}),Z(Mt,{colorToken:"foreground-primary",children:e})]})})});import{useState as Dt}from"react";import{Accordion as $t,Row as Ot}from"@appcues/sonar";import{Accordion as j,Icon as Wt}from"@appcues/sonar";import z,{css as Ye}from"styled-components";import ue,{css as Et}from"styled-components";import{Row as Bt,Text as Ve}from"@appcues/sonar";var Ft=Et`
  padding: 0 var(--spacing-regular);
`,Q=ue.div`
  a {
    height: ${({variant:e="regular"})=>e==="regular"?"40px":"64px"};
    display: flex;
    text-decoration: none;
    padding: 0 var(--spacing-large);
    ${({isSubItem:e})=>e&&Ft}
    transition: background-color 0.3s ease;

    svg {
      display: block;
      // We use 18px because the banners icon requires a width of 18px
      width: 18px;

      path {
        transition: fill 0.3s ease;
      }
    }

    &.active {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      ${Ve} {
        font-weight: var(--font-weight-bold);
      }

      svg path {
        fill: var(--color-blurple-600);
      }
    }

    :hover {
      background-color: var(--color-neutral-50);
      border-radius: var(--border-radius-small);

      svg path {
        fill: var(--color-blurple-600);
      }
    }
  }
`,Ke=ue(Bt)`
  max-width: 100%;
`,qe=ue(Ve).attrs({forwardedAs:"span"})`
  flex: 1;
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;var fe=Ye`
  fill: var(--color-blurple-600);
`,ve=z(Wt)`
  display: block;
  // 18px is used so that the accordion icon aligns with the other nav item icons
  width: 18px;

  path {
    transition: fill 0.3s ease;
    // The active state is determined programatically because when the accordion is closed the active list item is reomved from the DOM
    ${({$isActive:e})=>e&&fe}
  }
`,Xe=Ye`
  background-color: var(--color-neutral-50);
  border-radius: var(--border-radius-small);
`,Je=z(j.Header)`
  height: 40px;
  display: flex;
  // The Sonar Accordion.Header has some padding that we need to override so that the correct hover background can be applied
  padding: 0;
  font-weight: var(--font-weight-regular);
  transition: background-color 0.3s ease;

  :hover {
    ${Xe};

    ${ve} {
      path {
        ${fe};
      }
    }
  }

  /* Shows accordion header as active if collapsed */
  &[data-state='closed'] {
    ${({$isActive:e})=>e&&Xe};
  }
`,Ze=z(j.Trigger)`
  color: var(--foreground-primary);
  padding-left: var(--spacing-large);
  padding-right: var(--spacing-regular);
`,Qe=z(j.Content)`
  p {
    // Padding of 26px is required so that the accordion content aligns correctly with the other nav item text
    padding-left: 26px;
  }

  // We don't want padding on the last list item because a 4px space is already provided by the flex gap
  li {
    &:not(:last-child) {
      padding-bottom: var(--spacing-x-small);
    }
  }
`,je=z(j.Item)`
  // These styles create a gap between the trigger and the content when the accordion is expanded, but
  // the gap is removed when the accordion is collapsed
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);

  // This selector is used to apply the blurple fill to the accordion icon when one of it's children is hovered
  &:has(div > li > a:hover) {
    div > svg > path {
      ${fe}
    }
  }

  ${Q} {
    margin-left: var(--spacing-x-large);
    margin-right: var(--spacing-small);
    position: relative;
    &::before {
      content: '';
      display: block;
      width: 1px;
      height: 100%;
      background-color: var(--color-neutral-300);
      position: absolute;
      left: 0;
      top: 0;
    }
  }
`;import{jsx as G,jsxs as oo}from"react/jsx-runtime";var Ht="@navigation/accordion_",eo={getAccordionKey(e){return`${Ht}${e}`},getAccordionValue(e){let t=this.getAccordionKey(e);return localStorage.getItem(t)},setAccordionValue(e,t){let i=this.getAccordionKey(e);Boolean(t)?localStorage.setItem(i,t):localStorage.removeItem(i)}},to=({children:e,text:t,icon:i,isActive:n})=>{let r=()=>{if(n)return t;let m=eo.getAccordionValue(t);if(m)return m},[s,a]=Dt(r()),c=m=>{a(m),eo.setAccordionValue(t,m)};return G($t.Root,{collapsible:!0,value:s,onValueChange:c,type:"single",$unstyled:!0,children:oo(je,{value:t,children:[G(Je,{$isActive:n,children:G(Ze,{children:oo(Ot,{spacing:"small",yAlign:"center",children:[G(ve,{icon:i,colorToken:"color-neutral-700",size:"small",$isActive:n}),t]})})}),G(Qe,{children:e})]})})};import{jsx as no}from"react/jsx-runtime";var io=({children:e,isActive:t,onClick:i})=>no(J,{children:no(Ue,{onClick:i,className:t?"active":"",children:e})});import{Icon as ao,Row as ro,Text as zt}from"@appcues/sonar";import{faChevronRight as Gt}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{jsx as ee,jsxs as so}from"react/jsx-runtime";var lo=({icon:e,label:t})=>so(ro,{xAlign:"space-between",yAlign:"center",children:[so(ro,{spacing:"small",yAlign:"center",children:[ee(Y,{children:ee(ao,{icon:e,colorToken:"foreground-secondary",size:"small"})}),ee(zt,{colorToken:"foreground-primary",forwardedAs:"span",children:t})]}),ee(ao,{icon:Gt,colorToken:"foreground-secondary",size:"small"})]});import{forwardRef as Ut}from"react";import{Icon as _t,NavigationMenu as Vt}from"@appcues/sonar";import{jsx as R,jsxs as Kt}from"react/jsx-runtime";var po=Ut(({children:e,icon:t,iconElement:i,NavLink:n,to:r,end:s,isActive:a,external:c=!1,isSubItem:m,variant:d="regular",title:p,...h},v)=>{let k=c||!n?"a":n;return R(Q,{isSubItem:m,variant:d,className:"accordion-link-item",children:R(Vt.Link,{asChild:!0,children:R(k,{ref:v,to:r,end:s,className:a?"active":"",...h,children:Kt(Ke,{fluid:!0,spacing:"small",yAlign:"center",children:[i&&i,t&&R(Y,{children:R(_t,{icon:t,colorToken:"foreground-secondary",size:"small"})}),R(qe,{colorToken:"foreground-primary",title:p||"",children:e})]})})})})});import{NavigationMenu as Yt}from"@appcues/sonar";import qt from"styled-components";import{Text as Xt}from"@appcues/sonar";var co=qt.button.attrs({type:"button"})`
  height: 40px;
  display: flex;
  align-items: center;
  padding: 0 var(--spacing-regular);
  transition: background-color 0.3s ease;
  border-color: transparent;
  background-color: transparent;
  width: 100%;
  border: 0;

  svg {
    display: block;
    // We use 18px because the banners icon requires a width of 18px
    width: 18px;

    path {
      transition: fill 0.3s ease;
    }
  }
  &.active {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    ${Xt} {
      font-weight: var(--font-weight-bold);
    }

    svg path {
      fill: var(--color-blurple-600);
    }
  }

  :hover {
    background-color: var(--color-neutral-50);
    border-radius: var(--border-radius-small);

    svg path {
      fill: var(--color-blurple-600);
    }
  }
`;import{jsx as mo}from"react/jsx-runtime";var go=({children:e,onClick:t,className:i})=>mo(Yt.Link,{asChild:!0,children:mo(co,{onClick:t,className:i,children:e})});var o={Wrapper:De,ScrollContainer:$e,NavList:He,Nav:Oe,NavItem:_e,NavButton:io,NavAccordion:to,NavTrigger:lo,LinkItem:po,ButtonItem:go};import{useEffect as he}from"react";function uo({user:e,account:t,cannyAppId:i,isOpen:n}){he(()=>{if(window.Canny&&t&&e){let{id:r,isTrial:s,tier:a,stripePlanId:c}=t,{fullname:m,email:d,id:p,job:h,crxVersion:v}=e;window.Canny("identify",{appID:i,user:{email:d,name:m||"anonymous",id:p,customFields:{job:h,crxVersion:v},companies:[{customFields:{isTrial:s,tier:a,stripePlanId:c},id:r,name:r}]}})}},[t,i,e]),he(()=>{!n&&window.Canny&&window.Canny("closeChangelog")},[n]),he(()=>{new MutationObserver(()=>{if(document.querySelector("[data-canny-changelog]"))try{window.Canny("initChangelog",{appID:i,position:"right",align:"bottom"})}catch(a){}}).observe(document.body,{childList:!0,subtree:!0})},[i])}import{Icon as an,Row as rn,Tooltip as sn}from"@appcues/sonar";import{faScrewdriverWrench as ln}from"@fortawesome/pro-solid-svg-icons/faScrewdriverWrench";import _ from"styled-components";import{Button as tn,Stack as nn,NavigationMenu as No}from"@appcues/sonar";import{Progress as en}from"@appcues/sonar";import on from"pluralize";import{differenceInDays as Jt}from"date-fns";var ke=(e,t)=>Jt(e,t),fo=e=>new Intl.DateTimeFormat(void 0,{year:"numeric",month:"short",day:"2-digit"}).format(e);var be=(e,t)=>!((e==null?void 0:e.stripePlanId)||(t==null?void 0:t.isExpired));import U from"styled-components";import{Skeleton as Zt}from"@studio/legacy-components";import{Button as Qt,Tooltip as jt}from"@appcues/sonar";var vo=U.div`
  text-align: center;
  gap: 8px;
  padding: 16px 24px 0 24px;
  display: flex;
  flex-direction: column;

  ${Zt} {
    width: 140px;
    height: 40px;
    margin: 0 auto;
  }

  ${Qt} {
    --link-color: #ffffff;
    --link-text-decoration: none;
    --link-visited-color: #ffffff;
  }
`,ho=U.div`
  font-weight: 700;
  color: rgb(57, 68, 85);
  font-size: 14px;
`,ko=U.div`
  display: flex;
  gap: 8px;
  flex-direction: column;
  width: 100%;
`,bo=U.div`
  width: 180px;
  white-space: pre-wrap;
  font-size: 0.75rem;
`,Io=U(jt)`
  width: 100%;
`;import{jsx as oe,jsxs as Ie}from"react/jsx-runtime";var Ne=({account:e={},trialStatus:t={},className:i,Link:n})=>{let{createdAt:r,expirationDate:s,isWebInstalled:a,lengthDays:c}=t;if(!be(e,t)||!r||!s)return null;let d=ke(new Date(s),new Date(r))+1,p=ke(new Date(s),new Date)+1,v=(d-p)/d,k=Math.round(v*100),x=p>7?"default":(p>3,"error"),w=Ie(bo,{children:["Trial expires on ",fo(new Date(s)),"."," ",a?"":`Install the Appcues SDK to extend your trial another ${c} days.`]});return Ie(vo,{className:i,children:[oe(Io,{placement:"right",content:w,children:Ie(ko,{children:[oe(ho,{children:`${p} ${on("day",p)} left in trial`}),oe(en,{value:k,max:100,variant:x})]})}),oe(n,{to:"/subscription",children:"Upgrade now"})]})};var te=_(No.Trigger)`
  height: 40px;
`,xo=_(nn).attrs({spacing:"large"})`
  padding: var(--spacing-large);
`,yo=_(Ne)`
  padding: 0;
`,xe=_(tn)`
  width: 100%;
  text-decoration: none;
`,E=_(No.Content)`
  position: absolute;
  transform: translateY(-40px);
  left: 100%;
  margin-left: var(--spacing-x-small);
  background-color: var(--color-neutral-0);
  border-radius: var(--border-radius-small);
  gap: var(--spacing-x-small);
  padding: var(--spacing-small) var(--spacing-x-small);
  box-shadow: var(--elevation-300);
  transform: translateY(-40px);
  width: 200px;

  ul {
    list-style: none;
    padding: 0;
    margin: 0;
  }
`;import{jsx as V,jsxs as Lo}from"react/jsx-runtime";var wo=({NavLink:e,isInstalled:t,account:i,trialStatus:n})=>Lo(xo,{children:[t?null:V(sn,{size:"regular",content:"In order to publish live experiences to your users, you'll have to install Appcues directly into your codebase. Don't worry...it's super easy. Click here to learn how!",children:V(xe,{variant:"secondary",fluid:!0,forwardedAs:e,to:"/settings/installation",children:Lo(rn,{spacing:"small",yAlign:"center",children:[V(an,{icon:ln}),"Install"]})})}),V(yo,{account:i,trialStatus:n,Link:r=>V(xe,{variant:"tertiary",forwardedAs:e,...r})})]});import{useState as Ro}from"react";import{faGear as gn}from"@fortawesome/pro-solid-svg-icons/faGear";import{faChevronRight as dn}from"@fortawesome/pro-solid-svg-icons/faChevronRight";import{faExternalLink as un}from"@fortawesome/pro-solid-svg-icons/faExternalLink";import{faArrowRightFromBracket as fn}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{Icon as ie,Row as Le,Stack as vn,Text as we,NavigationMenu as ae}from"@appcues/sonar";import S from"styled-components";import{Text as Ao,Stack as pn,Row as cn}from"@appcues/sonar";import{Separator as mn}from"@radix-ui/react-separator";var So=S(pn).attrs({spacing:"x-small"})`
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,To=S(E)`
  transform: translateY(-105%);
  width: 237px;
`,Po=S(cn)`
  max-width: calc(100% - var(--spacing-large));
`,ne=S(Ao).attrs({colorToken:"foreground-primary",forwardedAs:"span",weight:"bold"})`
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`,Co=S.div`
  display: flex;
  padding: var(--spacing-small) var(--spacing-regular);
  cursor: pointer;
`,Mo=S(Ao)`
  padding-left: 22px;
  text-align: left;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 100%;
`,ye=S(mn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
`;import{jsx as f,jsxs as A}from"react/jsx-runtime";var Eo=({NavLink:e,onLogout:t,user:{email:i,fullName:n}={},companyName:r,accountsCount:s})=>{let a=r||i||"",[c,m]=Ro(),[d,p]=Ro(!1),h=v=>{c&&!d&&(v.preventDefault(),p(!0)),c&&d&&p(!1)};return f(ae.Root,{orientation:"vertical",value:c,onValueChange:v=>{m(v),v||p(!1)},children:f(ae.List,{children:A(ae.Item,{value:"account-menu",children:[f(ae.Trigger,{onClick:h,children:A(So,{children:[A(Le,{xAlign:"space-between",yAlign:"center",children:[A(Po,{spacing:"small",yAlign:"center",children:[f(ie,{icon:gn,colorToken:"foreground-secondary",size:"small"}),f(ne,{title:a,children:a})]}),f(ie,{icon:dn,colorToken:"foreground-secondary",size:"small"})]}),n&&f(Mo,{title:n,size:"small",children:n})]})}),f(To,{children:A("ul",{children:[s>1?f(o.LinkItem,{isSubItem:!0,variant:"tall",NavLink:e,to:"/accounts-v2",children:A(vn,{spacing:"x-small",children:[f(ne,{title:a,children:a}),f(we,{size:"small",children:"Switch Accounts"})]})}):f(Co,{children:f(ne,{title:a,children:a})}),f(ye,{}),f(o.LinkItem,{isSubItem:!0,NavLink:e,to:"/settings/account",children:"Settings"}),f(o.LinkItem,{external:!0,isSubItem:!0,"data-canny-link":!0,href:"https://feedback.appcues.com/product-feedback?sort=top",target:"_blank",children:"Suggest a feature"}),f(o.LinkItem,{external:!0,isSubItem:!0,href:"https://status.appcues.com",target:"_blank",children:A(Le,{xAlign:"space-between",yAlign:"center",children:[f(we,{forwardedAs:"span",children:"Appcues status"}),f(ie,{icon:un,colorToken:"foreground-link"})]})}),f(ye,{}),f("li",{children:f(o.ButtonItem,{onClick:t,children:A(Le,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[f(we,{colorToken:"foreground-primary",forwardedAs:"span",children:"Sign out"}),f(ie,{colorToken:"foreground-secondary",icon:fn})]})})})]})})]})})})};import B from"styled-components";import{NavigationMenu as Bo,Row as hn}from"@appcues/sonar";import{Separator as kn}from"@radix-ui/react-separator";var F=B(kn)`
  height: 1px;
  background: var(--border-default);
  margin: 0px var(--spacing-regular);
  padding: 0.1px 0 0 0;
`,re=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-regular);
  height: 100%;
  overflow-y: auto;
`,Fo=B(Bo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  & ul {
    list-style-type: none;
  }
`,Wo=B(Bo.Root)`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  overflow-y: auto;

  & ul {
    list-style-type: none;
  }
`,K=B.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-x-small);
`,Do=B(hn).attrs({spacing:"x-small",yAlign:"center",xAlign:"center"})`
  background: var(--color-neutral-100);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-x-small);
  color: var(--foreground-secondary);

  svg path {
    fill: var(--foreground-secondary) !important;
  }
`;import{useState as _o}from"react";import{NavigationMenu as pe}from"@appcues/sonar";import{faFolderMagnifyingGlass as Rn}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as En}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as Bn}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faUsers as Oo}from"@fortawesome/pro-solid-svg-icons/faUsers";import{faArrowsTurnToDots as bn}from"@fortawesome/pro-solid-svg-icons/faArrowsTurnToDots";import{faMessages as In}from"@fortawesome/pro-solid-svg-icons/faMessages";import{faMap as Ho}from"@fortawesome/pro-solid-svg-icons/faMap";import{faThumbtack as Nn}from"@fortawesome/pro-solid-svg-icons/faThumbtack";import{faCheckCircle as xn}from"@fortawesome/pro-solid-svg-icons/faCheckCircle";import{faComment as yn}from"@fortawesome/pro-solid-svg-icons/faComment";import{faRocket as Ln}from"@fortawesome/pro-solid-svg-icons/faRocket";import{faChartColumn as zo}from"@fortawesome/pro-solid-svg-icons/faChartColumn";import{faBullseye as wn}from"@fortawesome/pro-solid-svg-icons/faBullseye";import{faChartPieSimple as An}from"@fortawesome/pro-solid-svg-icons/faChartPieSimple";import{faBuildings as Sn}from"@fortawesome/pro-solid-svg-icons/faBuildings";import{faTh as Tn}from"@fortawesome/pro-solid-svg-icons/faTh";import{faRectangleCode as Pn}from"@fortawesome/pro-solid-svg-icons/faRectangleCode";import{NavigationMenu as se}from"@appcues/sonar";import{faEnvelopeOpen as Cn}from"@fortawesome/pro-solid-svg-icons";import{jsx as $o}from"react/jsx-runtime";var W=()=>$o("svg",{width:"18",height:"16",viewBox:"0 0 18 16",fill:"none",xmlns:"http://www.w3.org/2000/svg",children:$o("path",{fillRule:"evenodd",clipRule:"evenodd",d:"M17.1258 5L14.902 8.00085L17.1246 11H1.1258L3.34967 7.99915L1.12706 5H17.1258ZM0.874146 11H0.874181L0.874181 5H0.874146V11Z",fill:"var(--foreground-secondary)"})});import{Fragment as Mn,jsx as u,jsxs as T}from"react/jsx-runtime";var Go={MESSAGING:[/^\/banners(\/.*)?$/,/^\/pins(\/.*)?$/,/^\/checklists(\/.*)?$/,/^\/nps(\/.*)?$/,/^\/nps-v2(\/.*)?$/,/^\/launchpads(\/.*)?$/,/^\/flows-v2(\/.*)?$/,/^\/embeds(\/.*)?$/],METRICS:[/^\/goals(\/.*)?$/,/^\/insights\/explorer(\/.*)?$/,/^\/insights\/charts(\/.*)?$/,/^\/email-performance(\/.*)?$/]},le=(e,t)=>t.some(i=>e.startsWith(i)),Uo=(e,t)=>t.some(i=>i.test(e)),Ae=({NavLink:e,currentPath:t,featureFlags:i,handleClick:n})=>{let{hasLaunchpads:r,hasNps2:s,hasOpenBuilderFlows:a}=i,c=le(t,["/flows","/mobile","/experiments"]),m=Uo(t,[...Go.MESSAGING])||c,d=le(t,["/audience/segments","/segments"]),p=le(t,["/audience/users"]),h=le(t,["/audience"])||d||p,v=Uo(t,[...Go.METRICS]);return T(Mn,{children:[u(se.Item,{children:u(o.LinkItem,{icon:bn,NavLink:e,to:"/workflows",children:"Workflows"},"/workflows")}),T(se.Item,{value:"messaging-menu",children:[u(te,{className:m?"active":"",onClick:k=>n(k,"messaging-menu"),children:u(o.NavTrigger,{icon:In,label:"Messaging"})}),u(E,{children:T("ul",{children:[u(o.LinkItem,{icon:Ho,NavLink:e,to:"/flows",isSubItem:!0,isActive:c,children:"Flows"},"/flows"),a&&u(o.LinkItem,{icon:Ho,NavLink:e,to:"/flows-v2",isSubItem:!0,children:"Flows 2.0"},"/flows-v2"),u(o.LinkItem,{icon:Pn,NavLink:e,to:"/embeds",isSubItem:!0,children:"Embeds"},"/embeds"),u(o.LinkItem,{iconElement:u(W,{}),NavLink:e,to:"/banners",isSubItem:!0,children:"Banners"},"/banners"),u(o.LinkItem,{icon:Nn,NavLink:e,to:"/pins",isSubItem:!0,children:"Pins"},"/pins"),u(o.LinkItem,{icon:xn,NavLink:e,to:"/checklists",isSubItem:!0,children:"Checklists"},"/checklists"),u(o.LinkItem,{icon:yn,NavLink:e,to:s?"/nps-v2":"/nps",isSubItem:!0,children:"NPS"},"/nps"),r&&u(o.LinkItem,{icon:Ln,NavLink:e,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]})})]}),T(se.Item,{value:"audiences-menu",children:[u(te,{className:h?"active":"",onClick:k=>n(k,"audiences-menu"),children:u(o.NavTrigger,{icon:Oo,label:"Audiences"})}),u(E,{children:T("ul",{children:[u(o.LinkItem,{icon:An,NavLink:e,to:"/audience/segments-v2",isSubItem:!0,isActive:d,children:"Segments"},"/audience/segments-v2"),u(o.LinkItem,{icon:Oo,NavLink:e,to:"/audience/users-v2",isSubItem:!0,isActive:p,children:"Users"},"/audience/users-v2"),u(o.LinkItem,{icon:Sn,NavLink:e,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]})})]}),T(se.Item,{value:"metrics-menu",children:[u(te,{className:v?"active":"",onClick:k=>n(k,"metrics-menu"),children:u(o.NavTrigger,{icon:zo,label:"Metrics"})}),u(E,{children:T("ul",{children:[u(o.LinkItem,{icon:wn,NavLink:e,to:"/goals",isSubItem:!0,children:"Goals"},"/goals"),u(o.LinkItem,{icon:zo,NavLink:e,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),u(o.LinkItem,{icon:Tn,NavLink:e,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),u(o.LinkItem,{icon:Cn,NavLink:e,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]})})]})]})};import{jsx as L,jsxs as Fn}from"react/jsx-runtime";function Se({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasLaunchpads:c,hasNps2:m,hasOpenBuilderFlows:d,hasDevTools:p}){let[h,v]=_o(),[k,x]=_o({}),w=(I,b)=>{h===b&&!k[b]&&(I.preventDefault(),x({[b]:!0})),h===b&&k[b]&&x({[b]:!1})},y=(I,b)=>{w(I,b)};return L(Fo,{orientation:"vertical",value:h,onValueChange:I=>{v(I),I||x({})},children:L(pe.List,{children:Fn(re,{children:[e&&s?s:null,t&&!i?null:L(pe.Item,{children:L(o.LinkItem,{icon:En,NavLink:n,to:"/",end:r,children:"Overview"})}),L(K,{children:L(Ae,{NavLink:n,currentPath:a,handleClick:(I,b)=>y(I,b),featureFlags:{hasLaunchpads:c,hasNps2:m,hasOpenBuilderFlows:d}})}),L(F,{}),L(pe.Item,{children:L(o.LinkItem,{icon:Rn,NavLink:n,to:"/folders",children:"Folders"})}),p&&L(pe.Item,{children:L(o.LinkItem,{icon:Bn,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{Icon as Wn,NavigationMenu as Te,Row as Dn}from"@appcues/sonar";import{trackEvent as $n}from"@studio/analytics";import{faArrowsTurnToDots as On,faMessages as Hn,faMap as Vo,faThumbtack as zn,faCheckCircle as Gn,faComment as Un,faChartColumn as Ko,faBullseye as _n,faEnvelopeOpen as Vn,faTh as Kn,faUsers as qo,faChartPieSimple as qn,faBuildings as Xn,faRocket as Yn,faChartLine as Jn,faFlask as Zn,faRectangleCode as Qn,faLightbulb as jn,faBarsFilter as ei,faGauge as oi}from"@fortawesome/pro-solid-svg-icons";import{faFolderMagnifyingGlass as ti}from"@fortawesome/pro-regular-svg-icons/faFolderMagnifyingGlass";import{faTableList as ni}from"@fortawesome/pro-solid-svg-icons/faTableList";import{faFlag as ii}from"@fortawesome/pro-solid-svg-icons/faFlag";import{faSparkles as ai}from"@fortawesome/pro-regular-svg-icons";import{jsx as l,jsxs as P}from"react/jsx-runtime";var ri=["/flows","/pins","/banners","/checklists","/nps","/embeds"],si=["/goals","/insights/explorer","/insights/charts","/insights/funnels","/email-performance"],li=["/audience/segments-v2","/audience/users-v2","/audience/accounts"];function Pe({hasAiAssistant:e,hasOverviewRedirect:t,isInstalled:i,NavLink:n,matchExactRoutes:r,actions:s,currentPath:a,hasNps2:c,hasOpenBuilderFlows:m,hasDevTools:d,hasAiInsights:p,hasFunnels:h,hasDashboards:v}){let k=ri.some(y=>a.startsWith(y)),x=si.some(y=>a.startsWith(y)),w=li.some(y=>a.startsWith(y));return l(Wo,{orientation:"vertical",children:l(Te.List,{children:P(re,{children:[e&&s?s:null,P(K,{children:[v&&l(o.LinkItem,{icon:oi,NavLink:n,to:"/dashboards",children:"Dashboards"}),t&&!i?null:l(o.LinkItem,{icon:ni,NavLink:n,to:"/",end:r,children:"Overview"}),p&&l(o.LinkItem,{NavLink:n,to:"/insights-feed",icon:jn,onClick:()=>{$n({name:"nav_click",properties:{navItemID:"insights-feed",navItemName:"Insights"}})},children:P(Dn,{xAlign:"space-between",yAlign:"center",spacing:"small",children:["Insights",l(Do,{children:l(Wn,{icon:ai,size:"small"})})]})})]}),P(K,{children:[P(o.NavAccordion,{isActive:k,text:"Experiences",icon:Hn,children:[l(o.LinkItem,{NavLink:n,to:"/flows",icon:Vo,isSubItem:!0,children:"Flows"},"/flows"),m&&l(o.LinkItem,{icon:Vo,NavLink:n,to:"/flows-v2",isSubItem:!0,title:"Flows 2.0",children:"Flows 2.0"},"/flows-v2"),l(o.LinkItem,{icon:Qn,NavLink:n,to:"/embeds",isSubItem:!0,title:"Embeds",children:"Embeds"},"/embeds"),l(o.LinkItem,{NavLink:n,to:"/pins",icon:zn,isSubItem:!0,children:"Pins"},"/pins"),l(o.LinkItem,{NavLink:n,to:"/banners",iconElement:l(W,{}),isSubItem:!0,children:"Banners"},"/banners"),l(o.LinkItem,{NavLink:n,to:"/checklists",icon:Gn,isSubItem:!0,children:"Checklists"},"/checklists"),l(o.LinkItem,{NavLink:n,to:c?"/nps-v2":"/nps",icon:Un,isSubItem:!0,children:"NPS"},"/nps"),l(o.LinkItem,{icon:Yn,NavLink:n,to:"/launchpads",isSubItem:!0,children:"Launchpads"},"/launchpads")]}),P(o.NavAccordion,{isActive:x,text:"Metrics",icon:Ko,children:[l(o.LinkItem,{NavLink:n,to:"/goals",icon:_n,isSubItem:!0,children:"Goals"},"/goals"),l(o.LinkItem,{icon:Ko,NavLink:n,to:"/insights/explorer",isSubItem:!0,children:"Events Explorer"},"/insights/explorer"),l(o.LinkItem,{icon:Kn,NavLink:n,to:"/insights/charts",isSubItem:!0,children:"Saved Charts"},"/insights/charts"),h&&l(o.LinkItem,{icon:ei,NavLink:n,to:"/insights/funnels",isSubItem:!0,children:"Funnels"},"/insights/funnels"),l(o.LinkItem,{NavLink:n,to:"/experiments",icon:Zn,isSubItem:!0,children:"Experiments"},"/experiments"),l(o.LinkItem,{NavLink:n,to:"/performance",icon:Jn,isSubItem:!0,children:"Flow Performance"},"/performance"),l(o.LinkItem,{title:"Email Performance",icon:Vn,NavLink:n,to:"/email-performance",isSubItem:!0,children:"Email Performance"},"/email-performance")]}),P(o.NavAccordion,{isActive:w,text:"Audiences",icon:qo,children:[l(o.LinkItem,{icon:qn,NavLink:n,to:"/audience/segments-v2",isSubItem:!0,children:"Segments"},"/audience/segments-v2"),l(o.LinkItem,{icon:qo,NavLink:n,to:"/audience/users-v2",isSubItem:!0,children:"Users"},"/audience/users-v2"),l(o.LinkItem,{icon:Xn,NavLink:n,to:"/audience/accounts",isSubItem:!0,children:"Accounts"},"/audience/accounts")]}),l(o.LinkItem,{NavLink:n,to:"/workflows",icon:On,children:"Workflows"},"/workflows")]}),l(F,{}),l(Te.Item,{children:l(o.LinkItem,{icon:ti,NavLink:n,to:"/folders",children:"Folders"})}),d&&l(Te.Item,{children:l(o.LinkItem,{icon:ii,NavLink:n,to:"/dev-tools",children:"Dev Tools"})})]})})})}import{jsx as C,jsxs as pi}from"react/jsx-runtime";var Xo=({user:e,account:t,accountsCount:i,onSpoof:n,onLogout:r,isSpoofing:s,NavLink:a,featureFlags:c,matchExactRoutes:m,isInstalled:d,trialStatus:p,cannyAppId:h,currentPath:v,actions:k})=>{let{hasDevTools:x,hasLaunchpads:w,hasOverviewRedirect:y,hasAiAssistant:I,hasNps2:b,hasOpenBuilderFlows:X,hasNav2025:ge,hasAiInsights:N,hasFunnels:ut,hasDashboards:ft}=c;return uo({user:e,account:t,cannyAppId:h,isOpen:!1}),pi(o.Wrapper,{children:[C(D,{user:e,onSpoof:n,isSpoofing:s}),C(O,{size:"large"}),ge?C(Pe,{hasDevTools:x,hasOverviewRedirect:y,isInstalled:d,NavLink:a,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:b,hasOpenBuilderFlows:X,hasAiAssistant:I,hasAiInsights:N,hasFunnels:ut,hasDashboards:ft}):C(Se,{hasDevTools:x,hasLaunchpads:w,hasOverviewRedirect:y,isInstalled:d,NavLink:a,matchExactRoutes:m,actions:k,currentPath:v,hasNps2:b,hasOpenBuilderFlows:X,hasAiAssistant:I}),C(wo,{NavLink:a,isInstalled:d,account:t,trialStatus:p}),C(F,{}),C(Eo,{user:e,companyName:t==null?void 0:t.name,NavLink:a,accountsCount:i,onLogout:r})]})};import{faCircleUser as ki}from"@fortawesome/pro-solid-svg-icons/faCircleUser";import{faPeopleGroup as bi}from"@fortawesome/pro-solid-svg-icons/faPeopleGroup";import{faCreditCard as Ii}from"@fortawesome/pro-regular-svg-icons/faCreditCard";import{faLaptopMobile as Ni}from"@fortawesome/pro-solid-svg-icons/faLaptopMobile";import{faPaperPlane as xi}from"@fortawesome/pro-solid-svg-icons/faPaperPlane";import{faPlug as yi}from"@fortawesome/pro-solid-svg-icons/faPlug";import{faDatabase as Li}from"@fortawesome/pro-solid-svg-icons/faDatabase";import{faGlobe as wi}from"@fortawesome/pro-solid-svg-icons/faGlobe";import{faSparkles as Ai}from"@fortawesome/pro-solid-svg-icons/faSparkles";import{faArrowRightFromBracket as Si}from"@fortawesome/pro-solid-svg-icons/faArrowRightFromBracket";import{faPalette as Ti}from"@fortawesome/pro-solid-svg-icons/faPalette";import{Icon as Pi,NavigationMenu as jo,Row as Ci,Text as Mi}from"@appcues/sonar";import ci from"styled-components";import{Button as mi,Icon as gi,Text as di,Tooltip as ui}from"@appcues/sonar";import{faChevronLeft as fi}from"@fortawesome/pro-solid-svg-icons/faChevronLeft";import{jsx as q}from"react/jsx-runtime";var vi=ci.div`
  justify-self: end;
`,Yo=({onClick:e})=>q(vi,{children:q(ui,{content:q(di,{size:"small",lineHeight:"large",colorToken:"foreground-tooltip",children:"Exit settings"}),placement:"bottom",children:q(mi,{title:"back link",variant:"tertiary",iconOnly:!0,onClick:e,children:q(gi,{icon:fi})})})});import{Text as hi}from"@appcues/sonar";import Ce from"styled-components";var Jo=Ce(hi)`
  padding-left: var(--spacing-large);
  padding-top: var(--spacing-regular);
  padding-bottom: var(--spacing-regular);
`,Zo=Ce.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  align-items: center;
`,Qo=Ce.div`
  padding-bottom: var(--spacing-small);
`;import{jsx as g,jsxs as M}from"react/jsx-runtime";var Ri=new Set(["/settings/integrations","/webhooks","/settings/keys","/integrations/webhooks","/integrations/connections"]),Ei=new Set(["/settings/events","/settings/properties","/settings/properties/users","/settings/properties/groups"]),Bi=["/settings/themes",/^\/themes(\/.*)?$/],Fi=["/settings/installation",/apps\/[^/]+$/],Wi=["/settings/emails/senders",/\/settings\/emails\/suppression-lists\/[^/]+$/],et=({NavLink:e,featureFlags:t,currentPath:i,user:n,onSpoof:r,isSpoofing:s,onClickBackArrow:a,onClickLogout:c,hasLocalizationAccess:m,actions:d})=>{let{hasIntegrationPageRedesign:p,hasMobileFlows:h,hasAIAssistant:v,hasSubscription:k}=t,x=Ri.has(i),w=Bi.some(N=>typeof N=="string"?N===i:N.test(i)),y=Ei.has(i),I=Fi.some(N=>typeof N=="string"?N===i:N.test(i)),b=Wi.some(N=>typeof N=="string"?N===i:N.test(i)),X=i.includes("/settings/emails/suppression-lists/"),ge=i.startsWith("/settings/properties");return M(o.Wrapper,{children:[g(D,{user:n,onSpoof:r,isSpoofing:s}),M(Zo,{children:[g(Yo,{onClick:a}),g(O,{})]}),g(jo.Root,{orientation:"vertical",children:g(jo.List,{children:v&&d?d:null})}),g(Jo,{size:"medium",weight:"semibold",children:"Settings"}),g(o.ScrollContainer,{children:g(o.Nav,{children:M(o.NavList,{children:[g(o.NavItem,{icon:ki,NavLink:e,to:"/settings/account",children:"Profile"}),g(o.NavItem,{icon:bi,NavLink:e,to:"/settings/team",children:"Team"}),k&&g(o.NavItem,{icon:Ii,NavLink:e,to:"/settings/subscription",children:"Subscription"}),g(o.NavItem,{icon:Ni,NavLink:e,to:"/settings/installation",isActive:I,children:h?"Apps & Installation":"Installation"}),g(o.NavItem,{icon:Ti,NavLink:e,to:"/settings/themes",isActive:w,children:"Themes"}),v&&g(o.NavItem,{icon:Ai,NavLink:e,to:"/settings/ai-assistant",children:"Appcues AI"}),M(o.NavAccordion,{text:"Emails",icon:xi,isActive:b,children:[g(o.NavItem,{NavLink:e,to:"/settings/emails/senders",children:"Senders"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/suppression-lists/unsubscribes",isActive:X,children:"Suppression Lists"}),g(o.NavItem,{NavLink:e,to:"/settings/emails/sending-behavior",children:"Sending Behavior"})]}),M(o.NavAccordion,{text:"Integrations",icon:yi,isActive:x,children:[g(o.NavItem,{NavLink:e,to:p?"/integrations/connections":"/settings/integrations",children:"Connections"}),g(o.NavItem,{NavLink:e,to:"/integrations/webhooks",children:"Webhooks"}),g(o.NavItem,{NavLink:e,to:"/settings/keys",children:"API Keys"})]}),M(o.NavAccordion,{text:"Data",icon:Li,isActive:y,children:[g(o.NavItem,{NavLink:e,to:"/settings/identifier",children:"Accounts & Users"}),g(o.NavItem,{NavLink:e,to:"/settings/events",children:"Events"}),g(o.NavItem,{NavLink:e,to:"/settings/properties/user",isActive:ge,children:"Properties"})]}),m&&g(o.NavItem,{icon:wi,NavLink:e,to:"/settings/localization",children:"Localization"})]})})}),g(o.NavList,{children:g(Qo,{children:g(o.NavButton,{onClick:c,children:M(Ci,{fluid:!0,xAlign:"space-between",yAlign:"center",children:[g(Mi,{colorToken:"foreground-primary",children:"Sign out "}),g(Pi,{colorToken:"foreground-secondary",size:"small",icon:Si})]})})})})]})};import Di from"styled-components";var ot=Di.div`
  flex: 0 0 220px;
  width: 220px;
  position: fixed;
  height: 100vh;
  background-color: var(--color-neutral-100);
  border-right: 1px solid var(--border-default);
  bottom: 0;
  left: 0;
  top: 0;
  z-index: 100;
`;import{jsx as $i}from"react/jsx-runtime";var tt=()=>$i(ot,{});import{useCallback as Oi,useEffect as Hi,useRef as zi}from"react";import{createPopup as Gi}from"@typeform/embed";var Ui={unmount:()=>{},open:()=>{}},_i="QD5X3rU2";function nt({size:e=60,formValues:t={}}){let i=zi(Ui);return Hi(()=>{let r={size:e,hidden:t};i.current=Gi(_i,r)},[i,e,t]),{handleClick:Oi(()=>i.current.open(),[i])}}import it from"styled-components";import{Link as Vi}from"@appcues/sonar";var at=it.span`
  --font-size-regular: var(--font-size-small);
  --foreground-link: var(--color-blurple-400);
  --link-text-decoration: none;
`,rt=it(Vi)``;import{jsx as st}from"react/jsx-runtime";var lt=({children:e,message:t,subject:i,user:n,mailto:r="support@appcues.com",...s})=>{let a=(n==null?void 0:n.fullName)||(n==null?void 0:n.fullname),{email:c}=n!=null?n:{},m=["Hi,",t,"Thanks!"].join(`

`),d={message:t,subject:i,text:m,mailto:r,...a&&{name:a},...c&&{email:c}},{handleClick:p}=nt({formValues:d});return st(at,{onClick:p,children:st(rt,{"data-testid":"typeform-beacon",icon:!1,...s,children:e})})};import{Text as Ji}from"@appcues/sonar";import Ki from"styled-components";import{Link as pt}from"@appcues/sonar";import{Link as qi}from"react-router-dom";import{jsx as ct}from"react/jsx-runtime";var Xi=({children:e,href:t,...i})=>t?ct(pt,{href:t,...i,children:e}):ct(pt,{forwardedAs:qi,...i,children:e}),ce=Ki(Xi)``;import me from"styled-components";var Yi=me.div`
  align-items: center;
  background: white;
  box-shadow: var(--elevation-200);
  display: flex;
  height: 48px;
  justify-content: center;
`,sp=me.div`
  position: sticky;
  width: 100%;
  top: 0;
  z-index: 9000;
  min-width: 870px;
`,mt=me(Yi)`
  background: var(--color-pink-600);
  color: white;
  gap: var(--spacing-small);
`,gt=me.div``;import{jsx as Me,jsxs as dt}from"react/jsx-runtime";var Zi=()=>Me(ce,{colorToken:"white",href:"#",onClick:e=>{e.preventDefault()},children:"Stop spoofing"});function Qi({accountId:e,spoofing:t,onDespoof:i}){return t?dt(mt,{"aria-live":"polite",role:"alert",children:[dt(Ji,{weight:"bold",colorToken:"white",children:["Spoofing Account ",e]}),Me(gt,{onClick:i,children:Me(Zi,{})})]}):null}export{W as BannerIcon,lt as BeaconLink,tt as BlankNavigation,ce as Link,Xo as MainNavigation,o as Navigation,et as SettingsNavigation,Qi as SpoofBanner,be as isTrialAccount};
//# sourceMappingURL=index.mjs.map